import dynamic from "next/dynamic";

export const CustomerDispatchDetails = dynamic(
  () => import("@/Components/Cards/DispatchCard/CustomerDispatchDetails")
);
export const OrderStatusCard = dynamic(
  () => import("@/Components/Cards/DispatchCard/DispatchOrderDetails")
);
export const DriverDispatchList = dynamic(
  () => import("@/Components/Cards/DispatchCard/DriverDispatchList")
);
export const DriversDispatchDetails = dynamic(
  () => import("@/Components/Cards/DispatchCard/DriversDispatchDetails")
);
export const VehicleDispatchDetails = dynamic(
  () => import("@/Components/Cards/DispatchCard/VehicleDispatchDetails")
);
export const VendorDispatchDetails = dynamic(
  () => import("@/Components/Cards/DispatchCard/VendorDispathDetails")
);
export const Maps = dynamic(() => import("@/Components/Map"));
export const CustomModal = dynamic(() => import("@/Components/Modal"));
export const CustomModalAdvanced = dynamic(() => import("@/Components/Modal/CustomModalAdvanced"));

export const CapabilityTags = dynamic(
  () => import("@/Components/CapabilityTags")
);
export const MapInfoCard = dynamic(
  () => import("@/Components/Cards/MapInfoCard")
);
export const VehicleInfo = dynamic(() => import("@/Components/VehicleInfo"));
export const FleetName = dynamic(() => import("@/Components/fleetName"));

export const MultiSelectFilter = dynamic(
  () => import("@/Components/CapabilitiesFilter")
);

export const CapabilitiesCard = dynamic(
  () => import("@/Components/Cards/CapabilitiesCard")
);
export const FilterButton = dynamic(() => import("@/Components/Filter"));
export const FormInput = dynamic(() => import("@/Components/Form/FormInput"));

export const DispatchCard = dynamic(
  () => import("@/Components/Cards/DispatchCard")
);
export const MultiFilter = dynamic(() => import("@/Components/MultiFilter"));

export const FleetCard = dynamic(() => import("@/Components/Cards/FleetCard"));

export const CreateFleetCard = dynamic(
  () => import("@/Components/Cards/CreateFleetCard")
);
export const EmployeeCard = dynamic(
  () => import("@/Components/Cards/EmployeeCard")
);
export const VehicleCard = dynamic(
  () => import("@/Components/Cards/VehicleCard")
);
export const FormCheckbox = dynamic(
  () => import("@/Components/Form/FormCheckbox")
);
export const FormSelectOptions = dynamic(
  () => import("@/Components/Form/FormSelectOptions")
);
export const FormSelector = dynamic(
  () => import("@/Components/Form/FormSelector")
);
export const FormTextArea = dynamic(
  () => import("@/Components/Form/FormTextArea")
);
export const FormUpload = dynamic(() => import("@/Components/Form/FormUpload"));

export const DriverDetailsCard = dynamic(
  () => import("@/Components/Cards/DriverDetailsCard")
);

export const VehicleDetailsCard = dynamic(
  () => import("@/Components/Cards/VehicleDetailsCard")
);

export const ServiceCard = dynamic(
  () => import("@/Components/Cards/ServiceCard")
);
export const TroubleShootDetails = dynamic(
  () => import("@/Components/Cards/DispatchCard/TroubleShootDetails")
)

const FormDatepicker = dynamic(
  () => import("@/Components/Form/FormDatepicker/index")
);
